import { defineComponent as i, openBlock as t, createElementBlock as o, mergeProps as u, unref as e, renderSlot as m, createElementVNode as n, createCommentVNode as V } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, f = { key: 1 }, Z = { key: 2 }, h = { key: 3 }, k = { key: 4 }, w = { key: 5 }, v = {
  name: "ScalarIconWaveSawtooth"
}, _ = /* @__PURE__ */ i({
  ...v,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = g(s);
    return (p, l) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      m(p.$slots, "default"),
      e(a) === "bold" ? (t(), o("g", A, l[0] || (l[0] = [
        n("path", { d: "M238.29,138.22l-104,64A12,12,0,0,1,116,192V85.47L30.29,138.22a12,12,0,0,1-12.58-20.44l104-64A12,12,0,0,1,140,64V170.53l85.71-52.75a12,12,0,1,1,12.58,20.44Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (t(), o("g", f, l[1] || (l[1] = [
        n("path", {
          d: "M128,64v64H24Zm104,64H128v64Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M236.19,134.81l-104,64A8,8,0,0,1,120,192V78.32L28.19,134.81a8,8,0,0,1-8.38-13.62l104-64A8,8,0,0,1,136,64V177.68l91.81-56.49a8,8,0,0,1,8.38,13.62Z" }, null, -1)
      ]))) : e(a) === "fill" ? (t(), o("g", Z, l[2] || (l[2] = [
        n("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-11.56,94.66-72,48A8,8,0,0,1,128,184a8,8,0,0,1-8-8V95L60.44,134.66a8,8,0,1,1-8.88-13.32l72-48A8,8,0,0,1,136,80v81.05l59.56-39.71a8,8,0,0,1,8.88,13.32Z" }, null, -1)
      ]))) : e(a) === "light" ? (t(), o("g", h, l[3] || (l[3] = [
        n("path", { d: "M235.14,133.11l-104,64A6,6,0,0,1,122,192V74.74L27.15,133.11a6,6,0,1,1-6.29-10.22l104-64A6,6,0,0,1,134,64V181.26l94.85-58.37a6,6,0,1,1,6.29,10.22Z" }, null, -1)
      ]))) : e(a) === "regular" ? (t(), o("g", k, l[4] || (l[4] = [
        n("path", { d: "M236.19,134.81l-104,64A8,8,0,0,1,120,192V78.32L28.19,134.81a8,8,0,0,1-8.38-13.62l104-64A8,8,0,0,1,136,64V177.68l91.81-56.49a8,8,0,0,1,8.38,13.62Z" }, null, -1)
      ]))) : e(a) === "thin" ? (t(), o("g", w, l[5] || (l[5] = [
        n("path", { d: "M234.1,131.41l-104,64a4,4,0,0,1-2.1.59,4,4,0,0,1-4-4V71.16L26.1,131.41a4,4,0,0,1-4.2-6.82l104-64A4,4,0,0,1,132,64V184.84l97.9-60.25a4,4,0,1,1,4.2,6.82Z" }, null, -1)
      ]))) : V("", !0)
    ], 16));
  }
});
export {
  _ as default
};
